/**
 * drag 対象判定の SSOT（issue #118）。
 * ドラッグ「中」プレビュー（Page）と「ドロップ確定」（finalizeDrag）の両方から呼び、
 * preview と commit の条件ドリフトを防ぐ。
 *
 * - group drag: 掴んだ badge が選択群(selectedIds)の一員 かつ 複数選択(>=2) なら選択群全体が対象。
 * - それ以外: 掴んだ badge 自身 + 同 beatIndex の和音 peer（従来挙動）。
 */
export interface DragTargetBadge {
  id: number;
  beatIndex: number | null;
}

export function isDragTarget(
  badge: DragTargetBadge,
  dragBadgeId: number,
  dragBeatIndex: number | null,
  selectedIds: ReadonlySet<number>,
): boolean {
  const groupMove = selectedIds.has(dragBadgeId) && selectedIds.size >= 2;
  if (groupMove) {
    return selectedIds.has(badge.id);
  }
  return badge.id === dragBadgeId
    || (dragBeatIndex !== null && badge.beatIndex === dragBeatIndex);
}
